// extracted by mini-css-extract-plugin
export var readonly = "_iw-1";
export var star = "_iw-0";